import {
  ButtonComponent,
  DrawerComponent,
  SelectComponent,
} from "@/components";
import { WEB_COLORS } from "@/lib/constants";
import {
  useGetIfscBankListQuery,
  useGetIfscBanksAddressListQuery,
  useGetIfscBanksCitiesListQuery,
  useGetIfscBanksIfscQuery,
  useGetIfscBanksStateListQuery,
} from "@/lib/redux";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import * as Yup from "yup";

const IfscDrawer = ({
  open,
  handleDrawer,
  schema,
  handleOnSubmit,
  initialValues,
}) => {
  const t = useTranslations("IFSCModal");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues ?? {
      bankIFSCCode: "",
      bankName: "",
      state: "",
      city: "",
      address: "",
    },
    validationSchema: Yup.object().shape({
      bankIFSCCode: Yup.string().required("IFSC Code is required"),
      bankName: Yup.string().required("Bank Name is required"),
      state: Yup.string().required("State is required"),
      city: Yup.string().required("City is required"),
      address: Yup.string().required("Area is required"),
    }),
    onSubmit: (values) => {
      handleOnSubmit && handleOnSubmit(values);
      handleDrawer(false);
      formik.resetForm();
    },
  });

  const { data: banksList } = useGetIfscBankListQuery();
  const { data: stateListData } = useGetIfscBanksStateListQuery(
    {
      bankName: formik?.values?.bankName,
    },
    { skip: !formik?.values?.bankName, refetchOnMountOrArgChange: true }
  );

  const { data: cityListData } = useGetIfscBanksCitiesListQuery(
    {
      bankName: formik.values.bankName,
      state: formik.values.state,
    },
    {
      skip: !formik.values.state || !formik.values.bankName,
      refetchOnMountOrArgChange: true,
    }
  );

  const { data: addressListData } = useGetIfscBanksAddressListQuery(
    {
      bankName: formik.values.bankName,
      state: formik.values?.state,
      city: formik.values?.city,
    },
    {
      skip:
        !formik.values.city || !formik.values.state || !formik.values.bankName,
      refetchOnMountOrArgChange: true,
    }
  );

  const { data: ifscBankData, isSuccess: isSuccessIfscBanksIfsc } =
    useGetIfscBanksIfscQuery(
      {
        bankName: formik.values.bankName,
        state: formik.values?.state,
        city: formik.values?.city,
        address: formik.values?.address,
      },
      {
        skip:
          !formik.values.city ||
          !formik.values.state ||
          !formik.values.bankName ||
          !formik.values.address,
        refetchOnMountOrArgChange: true,
      }
    );

  useEffect(() => {
    if (isSuccessIfscBanksIfsc) {
      formik.setFieldValue("bankIFSCCode", ifscBankData?.data[0]?.key);
    }
  }, [ifscBankData]);
  return (
    <DrawerComponent
      title={"Search IFSC Code"}
      open={open}
      handleDrawer={handleDrawer}
    >
      <Stack rowGap={2}>
        <Grid container spacing={2} rowGap={2}>
          <Grid item xs={12}>
            <SelectComponent
              label={t("bankname")}
              value={formik.values.bankName}
              menuItems={banksList?.data.map((item, i) => {
                return {
                  id: item?.id,
                  name: item?.key,
                  value: item?.key,
                };
              })}
              disabled={schema?.bankName?.disabled}
              onChange={(e) => {
                formik.setFieldValue("bankName", e.target.value);
                formik.setFieldValue("state", "");
                formik.setFieldValue("city", "");
                formik.setFieldValue("address", "");
                formik.setFieldValue("bankIFSCCode", "");
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectComponent
              label={t("state")}
              value={formik.values.state}
              menuItems={stateListData?.data.map((item, i) => {
                return {
                  id: item?.id,
                  name: item?.key,
                  value: item?.key,
                };
              })}
              onChange={(e) => {
                formik.setFieldValue("state", e.target.value);
                formik.setFieldValue("city", "");
                formik.setFieldValue("address", "");
                formik.setFieldValue("bankIFSCCode", "");
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectComponent
              label={t("city")}
              value={formik.values.city}
              menuItems={cityListData?.data.map((item, i) => {
                return {
                  id: item?.id,
                  name: item?.key,
                  value: item?.key,
                };
              })}
              defaultValue=""
              onChange={(e) => {
                formik.setFieldValue("city", e.target.value);
                formik.setFieldValue("address", "");
                formik.setFieldValue("bankIFSCCode", "");
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectComponent
              label={t("area")}
              value={formik.values.address}
              menuItems={addressListData?.data.map((item, i) => {
                return {
                  id: item?.id,
                  name: item?.key,
                  value: item?.key,
                };
              })}
              defaultValue=""
              onChange={(e) => {
                formik.setFieldValue("address", e.target.value);
                formik.setFieldValue("bankIFSCCode", "");
              }}
            />
          </Grid>
        </Grid>
        {formik.values.bankIFSCCode && (
          <Stack bgcolor={"#F2F7F799"} p={2}>
            <Typography>
              IFSC Code: {}
              <strong style={{ color: WEB_COLORS.primary }}>
                {isSuccessIfscBanksIfsc ? formik.values.bankIFSCCode || "" : ""}
              </strong>
            </Typography>
          </Stack>
        )}
        <ButtonComponent
          disabled={!(formik.dirty && formik.isValid)}
          type="submitifsc"
          onClick={formik.handleSubmit}
        >
          Proceed
        </ButtonComponent>
      </Stack>
    </DrawerComponent>
  );
};

export default IfscDrawer;
